import StorageUtil from "@/utils/StorageUtil";
import axios from "axios";
import config from "@/config";
import SessionUtil from "@/utils/SessionUtil";

export default {

    getDefaultConfig() {
        return {
            //通用设置
            isHomePopup: true,                                          //首页弹窗
            isRecordSearch: false,                                      //记录搜索记录
            //代叫设置
            isProhibitProxy: false,                                     //禁止代叫
            proxyBlacklist: [],                                         //代叫黑名单
            //乘车偏好设置
            orderCarTypes: {"ORDER_CAR_TYPE_NORMAL_TAXI": true, "ORDER_CAR_TYPE_ONLINE_TAXI": true},  //叫车车型
            waitingTimeout: 15,                                         //叫车超时时长
            //通勤设置
            homeAddress: null,                                          //住宅地址
            homeAddressLongitude: null,                                 //住宅地址经度
            homeAddressLatitude: null,                                  //住宅地址纬度
            workAddress: null,                                          //公司地址
            workAddressLongitude: null,                                 //公司地址经度
            workAddressLatitude: null,                                  //公司地址纬度
        }
    },

    getSetting() {
        const that = this;
        return new Promise(async function (resolve, reject) {
            await axios.get(config.api + '/userConfiguration/get/customer', {
                params: {}
            }).then(function (response) {
                // 数据格式
                const rs = response.data;
                if (!("success" in rs)) rs.success = rs.code === 200;
                if (!("result" in rs)) rs.result = rs.data;
                if (rs.success && rs.result) {
                    const setting = that.getDefaultConfig();
                    setting.isHomePopup = rs.result.home_page_popover === "TRUE";
                    setting.isRecordSearch = rs.result.record_search_history === "TRUE";
                    setting.isProhibitProxy = rs.result.behalf_of_strategy === "TRUE";
                    setting.proxyBlacklist = rs.result.behalf_of_blacklist?.split(",");
                    setting.waitingTimeout = rs.result.time_out_period ? rs.result.time_out_period : 15;
                    setting.orderCarTypes = JSON.parse(rs.result.order_car_types);
                    setting.homeAddress = rs.result.home_address;
                    setting.homeAddressLongitude = rs.result.home_address_longitude;
                    setting.homeAddressLatitude = rs.result.home_address_latitude;
                    setting.workAddress = rs.result.work_address;
                    setting.workAddressLongitude = rs.result.work_address_longitude;
                    setting.workAddressLatitude = rs.result.work_address_latitude;

                    StorageUtil.setObject("setting", setting);
                    resolve({response: response, success: true, setting: setting});
                } else {
                    resolve({response: response, success: false});
                }
            }).catch(function (error) {
                reject(error);
            });
        });
    },

    setSetting(setting) {
        return new Promise(function (resolve, reject) {
            axios.put(config.api + '/userConfiguration/set/customer', {
                behalf_of_blacklist: JSON.stringify(setting.proxyBlacklist),
                behalf_of_strategy: setting.isProhibitProxy ? 1 : 0,
                home_page_popover: setting.isHomePopup ? "TRUE" : "FALSE",
                record_search_history: setting.isRecordSearch ? "TRUE" : "FALSE",
                time_out_period: setting.waitingTimeout,
                order_car_types: JSON.stringify(setting.orderCarTypes),
                home_address: setting.homeAddress,
                home_address_longitude: setting.homeAddressLongitude,
                home_address_latitude: setting.homeAddressLatitude,
                work_address: setting.workAddress,
                work_address_longitude: setting.workAddressLongitude,
                work_address_latitude: setting.workAddressLatitude,
            }).then(function (response) {
                const rs = response.data;
                // 数据格式
                if (!("success" in rs)) rs.success = rs.code === 200;
                if (!("result" in rs)) rs.result = rs.data;
                if (rs.success) {
                    StorageUtil.setObject("setting", setting);
                    resolve({response: response, success: true, setting: setting});
                } else {
                    resolve({response: response, success: false});
                }
            }).catch(function (error) {
                reject(error);
            });
        });
    },
}
